import { render, staticRenderFns } from "./TravelModal.vue?vue&type=template&id=c234a912&"
import script from "./TravelModal.vue?vue&type=script&lang=js&"
export * from "./TravelModal.vue?vue&type=script&lang=js&"
import style0 from "./TravelModal.vue?vue&type=style&index=0&id=c234a912&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports